const dev = 'https://cxx.cardsvault.net'
// const dev = 'http://8.130.92.97:8080'
// const dev = 'https://preview.cardsvault.net'
//线上：  https://cxx.cardsvault.net
//本地：  http://8.130.92.97:8080
// 测试:  https://preview.cardsvault.net


export default dev